/**
 * DIBAI 18K — Portafolio
 * assets/portafolio-dibai.js  v1.0.0
 */
(function () {
  'use strict';

  function toEmbed(url) {
    if (!url) return null;
    let m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([A-Za-z0-9_-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0&playsinline=1`;
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}?autoplay=1`;
    m = url.match(/tiktok\.com\/.+\/video\/(\d+)/);
    if (m) return `https://www.tiktok.com/embed/v2/${m[1]}`;
    return null;
  }

  function init(root) {
    const lb      = root.querySelector('[data-ptf-lightbox]');
    const content = root.querySelector('[data-ptf-content]');
    const counter = root.querySelector('[data-ptf-counter]');
    const prevBtn = root.querySelector('[data-ptf-prev]');
    const nextBtn = root.querySelector('[data-ptf-next]');
    if (!lb) return;

    let slides = [];
    let current = 0;
    let lastFocus = null;

    try {
      const dataEl = root.querySelector('[id^="ptf-data-"]');
      slides = JSON.parse(dataEl?.textContent || '[]');
    } catch (e) {}

    /* ── Lightbox ── */
    function open(idx) {
      lastFocus = document.activeElement;
      current   = idx;
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      render();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      stopMedia();
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      lastFocus?.focus();
    }

    function go(idx) {
      stopMedia();
      current = ((idx % slides.length) + slides.length) % slides.length;
      render();
    }

    function stopMedia() {
      content?.querySelectorAll('video').forEach(v => { v.pause(); v.src = ''; });
      content?.querySelectorAll('iframe').forEach(f => { f.src = ''; });
    }

    function render() {
      const slide = slides[current];
      if (!slide || !content) return;
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
      content.innerHTML = '';

      if (slide.type === 'video' && slide.video) {
        const embed = toEmbed(slide.video);
        if (embed) {
          const wrap = document.createElement('div');
          wrap.className = 'ptf-lb-iframe-wrap';
          const iframe = document.createElement('iframe');
          iframe.src = embed;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          wrap.appendChild(iframe);
          content.appendChild(wrap);
        } else {
          const video = document.createElement('video');
          video.className   = 'ptf-lb-video';
          video.controls    = true;
          video.autoplay    = true;
          video.playsinline = true;
          const source = document.createElement('source');
          source.src = slide.video;
          video.appendChild(source);
          content.appendChild(video);
        }
      } else if (slide.image) {
        const img = document.createElement('img');
        img.className = 'ptf-lb-img';
        img.src       = slide.image;
        img.alt       = slide.title || 'Pieza DIBAI 18K';
        img.decoding  = 'async';
        content.appendChild(img);
      }

      /* Caption */
      if (slide.title || slide.subtitle) {
        const cap = document.createElement('div');
        cap.className = 'ptf-lb-caption';
        if (slide.title) {
          const t = document.createElement('p');
          t.className   = 'ptf-lb-caption__title';
          t.textContent = slide.title;
          cap.appendChild(t);
        }
        if (slide.subtitle) {
          const s = document.createElement('span');
          s.className   = 'ptf-lb-caption__sub';
          s.textContent = slide.subtitle;
          cap.appendChild(s);
        }
        content.appendChild(cap);
      }
    }

    function onKey(e) {
      if (e.key === 'Escape')     close();
      if (e.key === 'ArrowRight') go(current + 1);
      if (e.key === 'ArrowLeft')  go(current - 1);
    }

    /* Botones */
    root.querySelectorAll('[data-ptf-open]').forEach(btn => {
      btn.addEventListener('click', () => open(parseInt(btn.dataset.ptfOpen, 10)));
    });
    lb.querySelectorAll('[data-ptf-close]').forEach(el => {
      el.addEventListener('click', close);
    });
    prevBtn?.addEventListener('click', () => go(current - 1));
    nextBtn?.addEventListener('click', () => go(current + 1));

    root.__ptfCleanup = () => document.removeEventListener('keydown', onKey);
  }

  function initAll() {
    document.querySelectorAll('.portafolio-dibai-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.portafolio-dibai-wrapper') || e.target.closest('.portafolio-dibai-wrapper');
    if (root) init(root);
  });
  document.addEventListener('shopify:section:unload', e => {
    const root = e.target.querySelector('.portafolio-dibai-wrapper') || e.target.closest('.portafolio-dibai-wrapper');
    if (root?.__ptfCleanup) root.__ptfCleanup();
  });
})();
